"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erc1155Template = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const wagmi_1 = require("wagmi");
const react_1 = require("react");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const mui_dialog_delete_1 = require("@dzambalaorg/mui-dialog-delete");
const draft_js_utils_1 = require("@dzambalaorg/draft-js-utils");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const provider_user_1 = require("@dzambalaorg/provider-user");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const buttons_1 = require("../../../../buttons");
const forms_1 = require("../../../../forms");
const wrappers_1 = require("../../../../wrappers");
const utils_1 = require("../../../../utils");
const dialogs_1 = require("../../../../dialogs");
const schemas_1 = require("./schemas");
const form_1 = require("./form");
const ERC1155_TEMPLATES_URL = "/erc1155/templates";
const emptyValues = {
    title: "",
    description: draft_js_utils_1.emptyStateString,
    price: mui_inputs_asset_1.emptyPrice,
    amount: "0",
};
const Erc1155Template = (props) => {
    const { service } = props;
    const { profile } = (0, provider_user_1.useUser)();
    const initialSearchValues = (0, react_1.useMemo)(() => {
        return (0, utils_1.templatesSearchParamsCreator)(profile)[service];
    }, [service, profile]);
    const isMd = (0, material_1.useMediaQuery)(theme => theme.breakpoints.down("md"));
    const { data, isLoading, isError, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount, refetch } = (0, react_hooks_1.useFetchQuery)(ERC1155_TEMPLATES_URL, { enableInfiniteScroll: isMd }, void 0, initialSearchValues);
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const { handleDelete } = (0, react_hooks_1.useDialogDelete)();
    const { address: account = "" } = (0, wagmi_1.useAccount)();
    const erc1155TemplateCreate = () => {
        openDialog(dialogs_1.GlobalDialogKeys.ERC1155_TEMPLATE_CREATE, emptyValues, {
            refetch,
            initialValues: emptyValues,
            message: "dialogs.create",
            testId: "Erc1155TemplateDialogForm",
            filter: schemas_1.erc1155TemplatesCreateFilter,
            url: ERC1155_TEMPLATES_URL,
            validationSchema: form_1.erc1155TemplatesValidationSchema,
            componentProps: {
                service,
                mode: "create",
            },
        });
    };
    const erc1155TemplateEdit = (template) => () => {
        openDialog(dialogs_1.GlobalDialogKeys.ERC1155_TEMPLATE_EDIT, template, {
            refetch,
            initialValues: template,
            message: "dialogs.edit",
            testId: "Erc1155TemplateDialogForm",
            url: `${ERC1155_TEMPLATES_URL}/${template.id}`,
            validationSchema: form_1.erc1155TemplatesValidationSchema,
            filter: schemas_1.erc1155TemplatesEditFilter,
            prepareInitialValues: (0, schemas_1.prepareErc1155TemplatesInitialValues)(service, profile.merchantId),
            componentProps: {
                service,
                mode: "edit",
            },
        });
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, { children: [(0, jsx_runtime_1.jsx)(mui_page_layout_1.Breadcrumbs, { path: ["dashboard", "erc1155", "erc1155.templates"] }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.PageHeader, { message: "pages.erc1155.templates.title", children: (0, jsx_runtime_1.jsx)(ui_kit_1.Button, { intent: "secondary", startIcon: (0, jsx_runtime_1.jsx)(icons_material_1.Add, {}), onClick: erc1155TemplateCreate, "data-testid": "Erc1155TemplateCreateButton", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "form.buttons.create" }) }) }), (0, jsx_runtime_1.jsx)(forms_1.TemplateSearchForm, { service: service, initialSearchValues: initialSearchValues, contractType: [types_1.TokenType.ERC1155], contractModule: [types_1.ModuleType.HIERARCHY] }), (0, jsx_runtime_1.jsx)(wrappers_1.WithCheckPermissionsListWrapper, { isLoading: !data && isLoading, isError: !data && isError, isEmpty: allRows.length === 0, count: allRows.length, children: allRows.map(template => ((0, jsx_runtime_1.jsxs)(styled_1.ListItem, { wrap: true, account: account, contract: template.contract, children: [(0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { sx: { width: 0.6 }, children: template.title }), (0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { sx: { width: { xs: 0.6, md: 0.2 } }, children: template.contract?.title }), (0, jsx_runtime_1.jsxs)(styled_1.ListActions, { dataTestId: "TemplateActionsMenuButton", children: [(0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: erc1155TemplateEdit(template), message: "form.buttons.edit", dataTestId: "TemplateEditButton", icon: icons_material_1.Create }), (0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleDelete(template), message: "form.buttons.delete", dataTestId: "TemplateDeleteButton", icon: icons_material_1.Delete, disabled: template.templateStatus === types_1.TemplateStatus.INACTIVE }), (0, jsx_runtime_1.jsx)(buttons_1.TemplateMintButton, { template: template })] })] }, template.id))) }), !isMd && totalCount > take && ((0, jsx_runtime_1.jsx)(styled_1.StyledPagination, { shape: "rounded", page: skip / take + 1, count: Math.ceil(totalCount / take), onChange: onChangePage })), isMd && hasNextPage && (0, jsx_runtime_1.jsx)("div", { ref: loadMoreRef, style: { height: "20px", margin: "20px 0" } }), (0, jsx_runtime_1.jsx)(mui_dialog_delete_1.DeleteDialog, { url: ERC1155_TEMPLATES_URL, refetch: refetch })] }));
};
exports.Erc1155Template = Erc1155Template;
//# sourceMappingURL=index.js.map